import { useEffect, type ReactElement } from "react";
import { PRODUCT_NAME } from "./config";

/** Sets the browser tab title, so tabs and history entries say which page they are. */
export function useTitle(title: string | undefined) {
  useEffect(() => {
    document.title = title ? `${title} · ${PRODUCT_NAME}` : PRODUCT_NAME;
  }, [title]);
}

/** Static title for a route. Detail pages call useTitle themselves once the record's name loads. */
export function Titled({ title, children }: { title: string; children: ReactElement }) {
  useTitle(title);
  return children;
}
